// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fe151b38","952":"e3ac9cdf"}[chunkId] + ".chunk.js";
};